module.exports = __webpack_public_path__ + "static/img/QRcode.781ce33.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/QRcode.jpg
// module id = ABMx
// module chunks = 7